import React, { useEffect, useState } from 'react';
import './category.scss';
import './headerCategory.scss';
import { useNavigate } from 'react-router-dom';

interface IHeaderCategory {
  setShowTopic: (id: boolean) => void;
  value: string;
  pageId: number;
}

const HeaderCategory = ({ value, setShowTopic, pageId }: IHeaderCategory) => {
  const [category, setCategory] = useState('');
  const [text, setText] = useState('');

  const upperStr = value.toUpperCase();
  const navigate = useNavigate();

  useEffect(() => {
    if (upperStr === 'ALL') {
      setCategory('all-circle');
      setText('text-all-circle');
    } else if (upperStr === 'BUSINESS') {
      setCategory('business-circle');
      setText('text-business-circle');
    } else if (upperStr === 'ECONOMY') {
      setCategory('economy-circle');
      setText('text-economy-circle');
    } else if (upperStr === 'CULTURE') {
      setCategory('cultures-circle');
      setText('text-cultures-circle');
    } else if (upperStr === 'ESG') {
      setCategory('esg-circle');
      setText('text-esg-circle');
    } else if (upperStr === 'POLITICS') {
      setCategory('politics-circle');
      setText('text-politics-circle');
    }
  }, [value, category]);

  const handleShowTopic = () => {
    if (upperStr === 'ALL') {
      navigate('/newsTopic/');
    } else {
      navigate(`/newsTopic/${pageId}`);
    }

    setShowTopic(false);
  };

  return (
    <>
      <div className={`HeaderCategory-box ${upperStr === 'POLITICS' ? 'border-b' : ''}`} onClick={() => handleShowTopic()}>
        <div className="left-box">
          <div className={`category-circle ${category}`} id={category}></div>
          <span id={text} className="circle-text">
            {upperStr}
          </span>
        </div>
        <div className="right-box">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="right-down-arrow"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 4.5 15 15m0 0V8.25m0 11.25H8.25" />
          </svg>
        </div>
      </div>
    </>
  );
};

export default HeaderCategory;
